import { createBrowserRouter } from 'react-router-dom'
import { landingRoutes } from './pageRoutes/landing'
import { professorRoutes } from './pageRoutes/professor'
import { dashboardRoutes, experienceDashboardRoutes } from './pageRoutes/dashboard'
import { statusRoutes } from './pageRoutes/status'

export const browserRouter = createBrowserRouter([
  ...landingRoutes,
  ...dashboardRoutes,
  ...experienceDashboardRoutes,
  ...statusRoutes,
  ...professorRoutes,
])
